<template>
  <div id="admin-app">
    <router-view v-if="loaded"></router-view>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      loaded: false,
      error: null
    };
  },
  methods: mapActions({
    fetchStores: 'stores/fetchStores',
    setStore: 'stores/setStore'
  }),
  computed: {
    ...mapGetters({
      stores: 'stores/stores',
      storeId: 'stores/storeId'
    })
  },
  async created() {
    const { storeId } = this.$route.params;

    try {
      await this.fetchStores();

      if (this.stores[storeId]) {
        this.setStore(storeId);
      } else {
        const defaultStore = Object.keys(this.stores)[0];
        this.$router.push(this.$route.path.replace(storeId, defaultStore));
      }

      this.loaded = true;
    } catch (e) {
      this.error = e;
    }
  }
};
</script>
